import withDebounce from '../../../../../incase-domain/components/utils/WithDebounce';
import NumberInput, {NumberInputProps} from '../NumberInput';

const DebouncedNumberInput = withDebounce<NumberInputProps, number | undefined>(NumberInput);

export default DebouncedNumberInput;
